import axios from "axios";
import BaseService from "./base.service";
import { API_ENDPOINTS } from "@iso/constants/apiEndpoints.constant";

export default class UploadService extends BaseService {
  manualFileUpload = (fileData) => {
    return this.axios.post(API_ENDPOINTS.HELP_MANUAL_UPLOAD, fileData);
  };

  createPresignedUploadUrl = (fileName) =>
    this.axios.post(API_ENDPOINTS.S3_PRESIGNED_UPLOAD_URL, { fileName });

  // Plain axios: the app instance adds Authorization and a JSON Content-Type, which S3 rejects.
  putToS3 = (url, headers, file) => axios.put(url, file, { headers: { ...(headers || {}) } });
}
